import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceEventCreationNotificationState = createStateReducer(initialState, {
  [events.createEventSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createEvent",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.createEventFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "createEvent",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceEventCreationNotificationState };
